// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDtXfPozucx0S6rhaMR2mtvxlGWa5Ps3xM',
    authDomain: 'echoadmin-416e2.firebaseapp.com',
    databaseURL: 'https://echoadmin-416e2.firebaseio.com',
    projectId: 'echoadmin-416e2',
    storageBucket: 'echoadmin-416e2.appspot.com',
    messagingSenderId: '883949752337',
    appId: '1:883949752337:web:4dd2cf4942c782e4c661b0'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
